import { useEffect, useState } from "react";
import app from "../components/app";

const taskSample = {
  task:"",
  created:"",
  modified:"",
  assigned:"",
  status:"",
}

const saveTask = function(data, callback) {
  data.data["modified"] = Date.now();
  app.fetchPut(`/tasks/${data.id}`, data.data).then(function(response){
    callback();
  });
}

function Tasks() {
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [task, setTask] = useState(JSON.parse(JSON.stringify(taskSample)));
  const [index, setIndex] = useState(null);
  const [liveInclude, setLiveInclude] = useState(localStorage.getItem("liveInclude")?localStorage.getItem("liveInclude"):"");
  

  useEffect(() => {
    Promise.all([app.fetchGet("/users"), app.fetchGet("/statuses")]).then((values) => {
      const nextUsers = [];
      for(var key in values[0]) {
        nextUsers.push({
          id:key,
          data:values[0][key]
        })
      }
      console.log(nextUsers);
      setUsers(nextUsers);

      const nextStatuses = [];
      for(var newKey in values[1]) {
        nextStatuses.push({
          id:newKey,
          data:values[1][newKey]
        })
      }
      setStatuses(nextStatuses);

      app.fetchGet("/tasks").then(function(response){
        //console.log(response)
        const nextTasks = [];
        for(var key in response) {
          nextTasks.push({
            id:key,
            data:response[key]
          })
        }
        setTasks(nextTasks);
      });
    });
    // app.fetchGet("/tasks").then(function(response){
    //   //console.log(response)
    //   const nextTasks = [];
    //   for(var key in response) {
    //     nextTasks.push({
    //       id:key,
    //       data:response[key]
    //     })
    //   }
    //   setTasks(nextTasks);
    // });
    // app.fetchGet("/users").then(function(response){
    //   //console.log(response)
    //   const nextTasks = [];
    //   for(var key in response) {
    //     nextTasks.push({
    //       id:key,
    //       data:response[key]
    //     })
    //   }
    //   console.log(nextTasks);
    //   setUsers(nextTasks);
    // });
    // app.fetchGet("/statuses").then(function(response){
    //   //console.log(response)
    //   const nextStatuses = [];
    //   for(var key in response) {
    //     nextStatuses.push({
    //       id:key,
    //       data:response[key]
    //     })
    //   }
    //   console.log(nextStatuses);
    //   setStatuses(nextStatuses);
    // });
  }, []);
  const addTask = function() {
    if(index !== null) {
      addUpdate();
      return false;
    }
    if(task.task === "") {
      alert("Please enter task!");
      return false;
    }
    const created = Date.now();
    task["created"] = created;
    task["modified"] = created;
    app.fetchPost("/tasks", task).then(function(response){
      //console.log(response);
      document.querySelector("#task").value = "";
      setTasks([...tasks, {id:response.name, data:task}])
      setTask(JSON.parse(JSON.stringify(taskSample)));
    });
  }
  const addUpdate= function() {
    if(task.task === "") {
      alert("Please enter task!");
      return false;
    }
    task["modified"] = Date.now();
    app.fetchPut(`/tasks/${tasks[index].id}`, task).then(function(response){
      //console.log(response);
      document.querySelector("#task").value = "";
      const nextTasks = [...tasks];
      nextTasks[index].data = task;
      setTasks(nextTasks);
      setTask(JSON.parse(JSON.stringify(taskSample)));
      setIndex(null);
    });
  }
  const editTask = function(index) {
    setIndex(index);
    setTask(tasks[index].data);
    document.querySelector("#task").value = tasks[index].data.task;
  }
  const onInput = function(event){
    const obj = event.currentTarget;
    const nextTask = JSON.parse(JSON.stringify(task));
    nextTask[obj.id] = obj.value;
    setTask(nextTask)
  }
  const onChange = function(event){
    const nextTasks = [...tasks];
    const obj = event.currentTarget;
    nextTasks[obj.getAttribute("data-index")].data[obj.getAttribute("id")] = obj.value;
    saveTask(nextTasks[obj.getAttribute("data-index")], function(){
      setTasks(nextTasks);
    })
  }
  const upateLiveInclude = function(mode) {
    localStorage.setItem("liveInclude", mode)
    setLiveInclude(mode)
  }
  const max = Math.max(...statuses.map(function(v){
    return v.data.sort;
  }));
  return <div className="container-fluid p-4 task-list">
 
    <div className="w-100 pb-3">

    <h1 className="d-inline">Task List</h1>
    <div className="btn-group me-2 btn-group-sm float-end">
  {
    statuses.map(function(v){
      if(parseInt(v.data.sort) === max) {
        return <>
        <button type="button" className={`btn btn-outline-secondary ${liveInclude === ""?"active":""}`} onClick={() => upateLiveInclude("")}>Include {v.data.title}</button>
        <button type="button" className={`btn btn-outline-secondary ${liveInclude === ""?"":"active"}`} onClick={() => upateLiveInclude(v.id)}>Exclude {v.data.title}</button>
        </>
      }
      return null;
    })
  }
</div>



</div>
    <div className="input-group mb-3 input-group-lg">
  <input type="text" className="form-control" placeholder="Add Your Task" id="task" onInput={onInput}  />
  <button className="btn btn-secondary" type="button" onClick={addTask}>ADD TASK</button>
</div>


    <div className="w-100">
   
    <ul className="list-group">
      {
        tasks.map(function(v, i){
          if(liveInclude !== "") {
            if(v.data.status === liveInclude) {
              return null;
            }
          }
          return <li key={v.id} className="list-group-item">
            {v.data.task}
<div className="float-end d-flex">


<select className="form-select form-select-sm me-2" id="assigned" data-index={i} onChange={onChange} defaultValue={v.data.assigned}>
<option value="">No Assigned</option>
  {
    users.map(function(v){
      return <option key={v.id} value={v.id}>{v.data.name}</option>
    })
  }
  
  
</select>
<select class="form-select form-select-sm me-2" id="status" data-index={i} onChange={onChange} defaultValue={v.data.status}>
  <option value="">Not Started</option>
  {
    statuses.map(function(v){
      return <option key={v.id} value={v.id}>{v.data.title}</option>
    })
  }
 
</select>
            <div className="btn-group">
  <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editTask(i)}>edit</button>
  <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editTask(i)}>delete</button>
</div>
</div>
          </li>
        })
      }
    </ul>

    
    </div>

  </div>
}

export default Tasks;
